var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10310",
    "data-name": "Group 10310",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.193,
    height: 27.679,
    viewBox: "0 0 37.193 27.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2314",
    "data-name": "Rectangle 2314",
    width: 37.193,
    height: 27.679,
    fill: "#101b2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10309",
    "data-name": "Group 10309",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28397",
    "data-name": "Path 28397",
    d: "M11.245,12.542A4.757,4.757,0,1,0,6.487,17.3a4.765,4.765,0,0,0,4.757-4.757m-6.92,0A2.162,2.162,0,1,1,6.487,14.7a2.163,2.163,0,0,1-2.162-2.162M0,22.922v3.46a1.3,1.3,0,0,0,1.3,1.3h10.38a1.3,1.3,0,0,0,1.3-1.3v-3.46a4.765,4.765,0,0,0-4.757-4.757H4.757A4.765,4.765,0,0,0,0,22.922m2.595,0a2.163,2.163,0,0,1,2.162-2.162h3.46a2.163,2.163,0,0,1,2.162,2.162v2.162H2.595ZM30.706,7.785a4.757,4.757,0,1,0,4.757,4.757,4.765,4.765,0,0,0-4.757-4.757m0,6.92a2.162,2.162,0,1,1,2.162-2.162A2.163,2.163,0,0,1,30.706,14.7m1.73,3.46h-3.46a4.765,4.765,0,0,0-4.757,4.757v3.46a1.3,1.3,0,0,0,1.3,1.3H35.9a1.3,1.3,0,0,0,1.3-1.3v-3.46a4.765,4.765,0,0,0-4.757-4.757m2.162,6.92H26.814V22.922a2.163,2.163,0,0,1,2.162-2.162h3.46A2.163,2.163,0,0,1,34.6,22.922ZM23.354,4.757A4.757,4.757,0,1,0,18.6,9.515a4.765,4.765,0,0,0,4.757-4.757m-6.92,0A2.162,2.162,0,1,1,18.6,6.92a2.163,2.163,0,0,1-2.162-2.162m7.352,15.137a1.3,1.3,0,0,0,1.3-1.3v-3.46a4.765,4.765,0,0,0-4.757-4.757h-3.46a4.765,4.765,0,0,0-4.757,4.757V18.6a1.3,1.3,0,0,0,1.3,1.3ZM14.7,15.137a2.163,2.163,0,0,1,2.162-2.162h3.46a2.163,2.163,0,0,1,2.162,2.162V17.3H14.7Z",
    fill: "#101b2d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon2);
export default __webpack_public_path__ + "static/media/social_icon2.5df4dc0f6b2fe2621e2cac653989992b.svg";
export { ForwardRef as ReactComponent };